/**
 * Clears all authentication-related storage: localStorage, sessionStorage, and indexedDB.
 * Called on logout to ensure no stale tokens or session data remain.
 */
export const clearAllStorage = async (): Promise<void> => {
  try {
    localStorage.clear();
    sessionStorage.clear();

    if (window.indexedDB) {
      const databases = await window.indexedDB.databases();
      databases.forEach((db) => {
        if (db.name) {
          window.indexedDB.deleteDatabase(db.name);
        }
      });
    }
  } catch (e) {
    console.warn('Storage cleanup failed:', e);
  }
};
